// SmoothScroll.js
import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';

const SmoothScroll = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // disable browser auto restoration (prevent flash)
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    let rafId = null;
    let created = false;

    const initLenis = () => {
      if (!window.lenis) {
        window.lenis = new Lenis({
          duration: 0.9,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          smooth: true,
          smoothTouch: true,
          lerp: 0.08,
          wheelMultiplier: 1,
        });
        window.__lenisCreatedBy = 'SmoothScroll';
        created = true;
      }

      const _raf = (time) => {
        if (window.lenis && typeof window.lenis.raf === 'function') {
          window.lenis.raf(time);
        }
        rafId = requestAnimationFrame(_raf);
      };
      rafId = requestAnimationFrame(_raf);
    };

    if (document.readyState === 'complete') {
      initLenis();
    } else {
      window.addEventListener('load', initLenis, { once: true });
    }

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      try {
        if (created && window.lenis && typeof window.lenis.destroy === 'function') {
          window.lenis.destroy();
          delete window.lenis;
          delete window.__lenisCreatedBy;
        }
      } catch (e) {}
    };
  }, []);

  return null;
};

export default SmoothScroll;



